import React from 'react'
import { createRoot } from 'react-dom/client'

import { getStorageProfile } from '../Data/SubscriptionCenterDataSource.js'

import EmailSubscriptionCenterMenu from './EmailSubscriptionCenterMenu.jsx'

class EmailSubscriptionCenterMenuElement extends HTMLElement {
  async connectedCallback() {
    const reactContainerId = 'email-subscription-center-menu-react-app'

    const reactContainer = document.createElement('div')

    reactContainer.setAttribute('id', reactContainerId)

    this.appendChild(reactContainer)

    const storageProfile = getStorageProfile()

    if (!storageProfile) {
      return
    }

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(<EmailSubscriptionCenterMenu storageProfile={storageProfile} />)
  }
}

customElements.define(
  'email-subscription-center-menu',
  EmailSubscriptionCenterMenuElement
)
